module.exports = __webpack_public_path__ + "066327b8f88e18d9e8c57dd60dca7b3b.png";